import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { I2070Form } from 'clickNgo/models/crud/forms'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IToolsCodeRules } from '../model/contactFlag'

export const fetchToolsCodeRules = async (
  options?: ICrudFetchOptions
): Promise<IToolsCodeRules[]> => {
  const source = CrudStore.get<I2070Form>(CrudStoreItem.ToolsCodeRules, options?.cacheKey)

  source.setPaging({
    page: 0,
    pageSize: 10000,
  })

  return source
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then(({ items }: { items: I2070Form[] }) => {
      if (items) {
        return items.map((item) => ({
          flagCode: item.FlagCode,
          market: item.Market,
          toolsFlagCode: item.ToolsFlagCode,
          type: item.Type,
        }))
      }
      return []
    })
    .catch((error) => {
      Logger.error('fetchToolsCodeRules', error)
      return []
    })
}
